import RewardIncomeComponent from "../../Component/IncomeReport/RewardIncomeComponent"

const RewardIncome = () => {
  return (
    <div className='page-body'>
      <RewardIncomeComponent />
    </div>
  )
}

export default RewardIncome